import { useState, useEffect } from "react";
import { ProSidebar, Menu, MenuItem } from "react-pro-sidebar";
import { Box, IconButton, Typography, useTheme } from "@mui/material";
import { Link } from "react-router-dom";
import "react-pro-sidebar/dist/css/styles.css";
import { tokens } from "../../theme";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import PersonOutlinedIcon from "@mui/icons-material/PersonOutlined";
import CalendarTodayOutlinedIcon from "@mui/icons-material/CalendarTodayOutlined";
import MenuOutlinedIcon from "@mui/icons-material/MenuOutlined";
import { useDispatch, useSelector } from "react-redux";
import secureLocalStorage from "react-secure-storage";
import { jwtDecode } from "jwt-decode";
import { ShowOneVendorDetail } from "../../../../context/Slice/VendorManagementSlice";
import "./VendorSidebar.css";

const BASE_URL = process.env.REACT_APP_BASE_URL;

const VendorSidebar = ({ isCollapsed, setIsCollapsed }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [selected, setSelected] = useState("Dashboard");
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);

  const dispatch = useDispatch();
  const token = secureLocalStorage.getItem("token");

  

  useEffect(() => {
    if (token) {
      const decoded = jwtDecode(token);
      const ID = decoded._id;
      dispatch(ShowOneVendorDetail(ID));
    }
  }, [dispatch, token]);

  useEffect(() => {
    const handleResize = () => {
      setScreenWidth(window.innerWidth);
      if (window.innerWidth < 768) {
        setIsCollapsed(true);
      }
    };

    window.addEventListener("resize", handleResize);
    handleResize(); // Check on initial render

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [setIsCollapsed]);

  const Vendordetails = useSelector(
    (state) => state.VendorManagementR.Vendordetail
  );
  const vendorDetail = Vendordetails.length ? Vendordetails[0] : {};


  let imagePath = "assets/dummyProfile.jpg";
  if (vendorDetail.OwnerImage) {
    const OwnerImage = JSON.parse(vendorDetail.OwnerImage);
    if (OwnerImage && OwnerImage.length > 0) {
      imagePath = `${BASE_URL}/uploads/${OwnerImage[0].filename}`;
    }
  }
  console.log(isCollapsed);

  return (
    <Box
      sx={{
        "& .pro-sidebar-inner": {
          background: `${colors.primary[400]} !important`,
        },
        "& .pro-icon-wrapper": {
          backgroundColor: "transparent !important",
        },
        "& .pro-inner-item": {
          padding: "5px 35px 5px 20px !important",
        },
        "& .pro-inner-item:hover": {
          color: "#868dfb !important",
        },
        "& .pro-menu-item.active": {
          color: "#6870fa !important",
        },
        height: "130%",
      }}
    >
      <ProSidebar
        collapsed={screenWidth < 768 ? true : isCollapsed}
        style={{ width: isCollapsed  ? "80px" : "250px",minWidth: isCollapsed  ? "80px" : "250px" }}
      >
        <Menu iconShape="square">
          {/* LOGO AND MENU ICON */}
          <MenuItem
            onClick={() => setIsCollapsed(!isCollapsed)}
            icon={isCollapsed ? <MenuOutlinedIcon /> : undefined}
            style={{ margin: "10px 0 20px 0", color: colors.grey[100] }}
          >
            {!isCollapsed && (
              <Box display="flex" justifyContent="end" ml="15px">
                <IconButton onClick={() => setIsCollapsed(!isCollapsed)}>
                  <MenuOutlinedIcon />
                </IconButton>
              </Box>
            )}
          </MenuItem>

          {/* Profile Section: Only show when sidebar is NOT collapsed */}
          {!isCollapsed && (
            <Box mb="25px">
              <Box display="flex" justifyContent="center" alignItems="center">
                {imagePath && (
                  <img
                    alt="profile-user"
                    width="100px"
                    height="100px"
                    src={imagePath}
                    style={{ cursor: "pointer", borderRadius: "50%" }}
                  />
                )}
              </Box>
              <Box textAlign="center">
                <Typography
                  variant="h2"
                  color={colors.grey[100]}
                  fontWeight="bold"
                  sx={{ m: "10px 0 0 0" }}
                >
                  {/* <h1 className="sitename">CEP</h1> */}
                </Typography>
                <Typography variant="h5" color={colors.greenAccent[500]}>
                  {vendorDetail.OwnerName || "Add your Name"}
                </Typography>
              </Box>
            </Box>
          )}

          <Box paddingLeft={isCollapsed ? undefined : "10%"}>
            <MenuItem
              title="Profile"
              to="/vendor-dashboard/Profile"
              icon={<PersonOutlinedIcon />}
              onClick={() => setIsCollapsed(true)}
            >
              Profile
              <Link to="/vendor-dashboard/Profile" />
            </MenuItem>
            <MenuItem
              title="Visit Website"
              to="/"
              icon={<HomeOutlinedIcon />}
              onClick={() => setIsCollapsed(true)}
            >
              Visit Website
              <Link to="/" />
            </MenuItem>
            <MenuItem
              title="Add Service"
              to="/vendor-dashboard/AddService"
              icon={<CalendarTodayOutlinedIcon />}
              onClick={() => setIsCollapsed(true)}
            >
              Add Service
              <Link to="/vendor-dashboard/AddService" />
            </MenuItem>
            <MenuItem
              title="Service"
              to="/vendor-dashboard/Serviceone"
              icon={<CalendarTodayOutlinedIcon />}
              onClick={() => setIsCollapsed(true)}
            >
              Service
              <Link to="/vendor-dashboard/Serviceone" />
            </MenuItem>
            <Typography
              variant="h6"
              color={colors.grey[300]}
              sx={{ m: "15px 0 5px 20px", fontSize: "23px", display: isCollapsed && "none" }}
            >
              Management
            </Typography>
            <MenuItem
              title="Events"
              to="/vendor-dashboard/VendorEvents"
              icon={<CalendarTodayOutlinedIcon />}
              onClick={() => setIsCollapsed(true)}
            >
              Events
              <Link to="/vendor-dashboard/VendorEvents" />
            </MenuItem>
            <MenuItem
              title="Booking Management"
              to="/vendor-dashboard/VendorBooking"
              icon={<PersonOutlinedIcon />}
              onClick={() => setIsCollapsed(true)}
            >
              Booking Management
              <Link to="/vendor-dashboard/VendorBooking" />
            </MenuItem>
            <MenuItem
              title="Available Slot"
              to="/vendor-dashboard/VendorCalendar"
              icon={<CalendarTodayOutlinedIcon />}
              onClick={() => setIsCollapsed(true)}
            >
              Available Slot
              <Link to="/vendor-dashboard/VendorCalendar" />
            </MenuItem>
            <MenuItem
              title="External Events Calendar"
              to="/vendor-dashboard/VendorCalendarOut"
              icon={<CalendarTodayOutlinedIcon />}
              onClick={() => setIsCollapsed(true)}
            >
              External Events Calendar
              <Link to="/vendor-dashboard/VendorCalendarOut" />
            </MenuItem>
          </Box>
        </Menu>
      </ProSidebar>
    </Box>
  );
};

export default VendorSidebar;
